'use client';
import { useMemo } from 'react';
import DrawReadonly from '@/components/property-selector/draw-readonly';
import { useGetIframeDimensions } from '@/hooks/use-get-iframe-dimensions';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { useIsMobileIframe } from '@/hooks/use-is-mobile-iframe';
import { type PatchedProject, type PatchedPropertyUnit } from '@/types';

type PropertySelectorProps = {
  openInNewTab?: boolean;
  project: PatchedProject;
  properties: PatchedPropertyUnit[];
};

export function PropertySelector(props: PropertySelectorProps) {
  const isMobile = useIsMobile();
  const isMobileIframe = useIsMobileIframe();
  const dimensions = useGetIframeDimensions();
  const isRenderedInIframe = useMemo(() => isMobile && isMobileIframe, [isMobile, isMobileIframe]);

  if (!props.project) return null;

  return (
    <div
      style={{
        height: isRenderedInIframe ? dimensions.height : 'auto',
        width: isRenderedInIframe ? dimensions.width : 'auto',
        position: 'relative',
      }}
    >
      <DrawReadonly {...props} />
    </div>
  );
}
